<template>
  <div class="no-supplier-wrapper">
    <div class="no-supplier-card">
      <div class="mascot-wrapper">
        <img src="@/assets/img/oops-icon.svg" alt="Oops icon" class="mascot" />
      </div>
      <div class="content-wrapper">
        <div class="title">Du er ikke tilknyttet en leverandør</div>
        <div class="subtitle">
          For å bruke Really! må du være tilknyttet en leverandør.<br />
          Ta kontakt med Really! på post@really.no.
        </div>
        <button class="signout-btn" @click="handleSignOut">Logg ut</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMsalAuthentication } from "@/composables/useMsalAuthentication";

const { signOut } = useMsalAuthentication();

const handleSignOut = async () => {
  await signOut();
};
</script>

<style scoped>
.no-supplier-wrapper {
  min-height: 100vh;
  width: 100vw;
  background: #f7f0fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-supplier-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 0px 10px rgba(29, 29, 29, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 420px;
  overflow: hidden;
}
.mascot-wrapper {
  width: 100%;
  background: #f7f0fa;
  height: 235px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.mascot {
  width: 72px;
  height: 134px;
  margin-top: 64px;
}
.content-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 24px 32px 24px;
  gap: 24px;
}
.title {
  font-size: 24px;
  font-weight: 600;
  color: #1d1d1d;
  font-family: "Montserrat", sans-serif;
}
.subtitle {
  font-size: 16px;
  color: #1d1d1d;
  font-family: "Montserrat", sans-serif;
}
.signout-btn {
  border-radius: 24px;
  background-color: #441b49;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 16.5px 20px;
  border: none;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  transition: background 0.2s;
}
.signout-btn:hover {
  background: #2d102f;
}
</style>
